import api from "../../api";
import { USER_INFO } from "@/const";

const getters = {
  getUserById: (state) => (id) => state.users.find((u) => u.Id === id),
  getterbyExec: (state) => (id) =>
    state.users.find((u) => u.CustomerServiceExec_ === id),
  getterbySeller: (state) => (id) =>
    state.users.find((u) => u.SalesPersonCode === id)
};

const state = {
  users: [],
  user: {
    UserID: null,
    UserName: null,
    FullName: null,
    PersonCode: null,
    CustomerServiceExec_: null,
    Email: null,
    ImageUrl: null,
    CompanySelected: null,
    Roles: [],
    IsSupervisor: false,
    DepartamentID: null,
    DirecctionID: null,
    PositionID: null
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  userInfo: ({ dispatch, commit, getters }) => {
    return new Promise((resolve, reject) => {
      // commit("setSplashScreen", true, { root: true });

      api
        .get(USER_INFO)
        .then((resp) => {
          commit("user", resp.data._userinfo);
          resolve(resp);
        })
        .catch((err) => {
          // commit("setSplashScreen", false, { root: true });
          reject(err);
        });
    });
  },
  asignerImageUrl: ({ commit, rootState }, { url }) => {
    return new Promise((resolve, reject) => {
      api
        .put(
          "api/users/ChangeImage",
          {
            ImageUrl: url
          },
          { params: { id: rootState.user.user.UserID } }
        )
        .then((resp) => {
          commit("imageUrl", url);
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchUsers: ({ commit }) => {
    return new Promise((resolve, reject) => {
      api
        .get("/api/users")
        .then(({ data }) => {
          commit("SET_USERS", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

const mutations = {
  user: (state, user) => {
    state.user = user;
  },
  imageUrl: (state, url) => {
    state.imageUrl = url;
  },
  SET_USERS: (state, users) => {
    state.users = users;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
